export const roundWithinLimits = (
  num: number,
  lower: number,
  upper: number,
  roundingThreshold = 0.5,
): number => {
  const decimal = num % 1;
  let roundedNum;
  if (decimal < roundingThreshold) {
    roundedNum = Math.floor(num);
  } else if (decimal === roundingThreshold) {
    roundedNum = num >= 0 ? Math.floor(num) : Math.ceil(num);
  } else {
    roundedNum = Math.ceil(num);
  }
  return Math.min(upper, Math.max(lower, Math.round(roundedNum)));
};

export const findClosesValueInArray = (
  values: number[],
  target: number,
): number => {
  return values.reduce((prev, cur) => {
    return Math.abs(cur - target) < Math.abs(prev - target) ? cur : prev;
  });
};

export const getBoundedValue = (value: number, lower: number, upper: number) => {
  return Math.min(upper, Math.max(lower, value));
};

export const calculateCircumference = (radius: number) => {
  return 2 * Math.PI * radius;
};

export const calculateCircularProgressOffset = (currentValue: number, circumference: number) => {
  const normaliseCurrentValue = Math.min(currentValue, 100);
  const maxPercentage = 100 * normaliseCurrentValue / 100;
  return  circumference - (circumference * maxPercentage) / 100;
};
